import { WebLayout } from 'components/Layout';
import React, { useEffect } from 'react';

export const DeleteAccount = () => {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  return (
    <WebLayout
      title="Terms & Conditions"
      description="Terms and conditions that govern your use of dejunk"
    >
      <div className="max-w-4xl mx-auto px-4 py-10">
        <h1 class="text-3xl font-bold mb-4">Account Management</h1>

        <p class="text-gray-600 mb-10">
          This page explains how to delete your Dejunk account and how to recover it if you change
          your mind.
        </p>

        <section class="mb-12">
          <h2 class="text-xl font-semibold mb-3">Delete Your Account</h2>

          <p class="text-gray-700 mb-4">
            You can request deletion of your account and associated data at any time.
          </p>

          <div class="bg-gray-50 border rounded-xl p-5">
            <p class="text-sm text-gray-600">Send a request to:</p>
            <p class="font-semibold text-lg mt-1">ashitacreatives@gmail.com</p>

            <p class="text-sm text-gray-600 mt-4">Include:</p>
            <ul class="list-disc ml-6 text-sm text-gray-700 mt-2 space-y-1">
              <li>Your registered phone number</li>
              <li>Your account name (if available)</li>
              <li>
                Subject: <span class="font-medium">Delete My Account</span>
              </li>
            </ul>
          </div>

          <div class="mt-6 text-sm text-gray-700">
            <strong>What happens next:</strong>
            <ul class="list-disc ml-6 mt-2 space-y-1">
              <li>Your account will be marked for deletion</li>
              <li>Your listings will be removed from public view</li>
              <li>Your phone number will no longer be visible</li>
            </ul>
          </div>
        </section>

        <section class="mb-12">
          <h2 class="text-xl font-semibold mb-3">Recover Your Account</h2>

          <p class="text-gray-700 mb-4">
            If you request deletion but change your mind, you may recover your account within a
            limited time.
          </p>

          <div class="bg-gray-50 border rounded-xl p-5">
            <p class="text-sm text-gray-600">To recover your account:</p>
            <p class="mt-2 text-gray-700 text-sm">
              Send an email to <span class="font-medium">ashitacreatives@gmail.com</span> with:
            </p>

            <ul class="list-disc ml-6 text-sm text-gray-700 mt-2 space-y-1">
              <li>Your registered phone number</li>
              <li>
                Subject: <span class="font-medium">Recover My Account</span>
              </li>
            </ul>
          </div>

          <p class="text-sm text-gray-600 mt-4">
            Recovery requests must be made before permanent deletion is completed.
          </p>
        </section>

        <section class="mb-12">
          <h2 class="text-xl font-semibold mb-3">Deletion Timeline</h2>

          <ul class="list-disc ml-6 text-gray-700 space-y-2">
            <li>
              Account is first placed in a <strong>pending deletion state</strong>
            </li>
            <li>
              You have up to <strong>7 days</strong> to recover your account
            </li>
            <li>After 7 days, your account and data are permanently deleted</li>
          </ul>
        </section>

        <section class="mb-12">
          <h2 class="text-xl font-semibold mb-3">Data Retention</h2>
          <p class="text-gray-700">
            Certain data (such as payment records) may be retained where required by law or for
            legitimate business purposes.
          </p>
        </section>

        <section class="mb-12">
          <div class="border border-red-200 bg-red-50 rounded-xl p-5">
            <h2 class="text-lg font-semibold text-red-600 mb-2">Important</h2>
            <p class="text-sm text-red-700">
              Once your account is permanently deleted, it cannot be recovered.
            </p>
          </div>
        </section>

        <div class="mt-10">
          <a href="/" class="text-sm text-gray-600 hover:text-black underline">
            ← Back to Home
          </a>
        </div>
      </div>
    </WebLayout>
  );
};
